export const CAPITAL_BASE_TYPE = [
  { id: 'NONE', displayValue: 'None' },
  { id: 'FIXED', displayValue: 'Fixed' },
  { id: 'FORWARD', displayValue: 'Forward' },
];
